import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import { useInView } from "react-intersection-observer";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as VocIcon } from './../../assets/voc.svg';
import StarIcon from '@mui/icons-material/Star';
import dayjs from 'dayjs';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import favoritesStore from '../../stores/favorites';
import performanceStore from '../../stores/performance';
import sessionStore from '../../stores/session';
import settingsStore from '../../stores/settings';
import accountStore from '../../stores/account';

function HistoryListItem(props) {

  const thisPerformance = performanceStore((state) => state.history?.items?.find(x => x.position == props.index));
  const sessionToken = sessionStore((state) => state.sessionToken);
  const deleteFavorite = favoritesStore((state) => state.deleteFavorite);
  const setFavorite = favoritesStore((state) => state.setFavorite);
  const timeDiff = accountStore((state) => state.timeDiff);
  const settingsUsageMode = settingsStore((state) => state.settings?.usage_mode);
  const isFavorite = favoritesStore(
    (state) => state.tracks?.find(x => x.track_id == thisPerformance?.track.track_id && x.is_favorite == 1)
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleSetFavorite = (event) => {
    event.stopPropagation();
    if (isFavorite) {
      deleteFavorite(sessionToken, thisPerformance?.track);
    } else {
      setFavorite(sessionToken, thisPerformance?.track);
    }
  };

  const lengthToMinutes = (length) => {
    if (length) {
      const splitted = length.split(":");
      if (splitted.length == 3) {
        return splitted[1] + ":" + splitted[2];
      }
    }
  };

  const renderStarIcon = () => {
    if (isFavorite) {
      return <StarIcon className="muvika-yellow-star" />;
    } else {
      return <StarIcon className="muvika-empty-star" />;
    }
  };

  const renderFavoritesStar = () => {
    if (settingsUsageMode) {
      if (settingsUsageMode === "restaurant") {
        return <IconButton className="muvika-list-star" color="white" component="label" size="large" onClick={handleSetFavorite}>
          {renderStarIcon()}
        </IconButton>;
      }
    } else {
      return <IconButton className="muvika-list-star" color="white" component="label" size="large" onClick={handleSetFavorite}>
        {renderStarIcon()}
      </IconButton>;
    }
  };

  const vocalImg = () => {
    if (thisPerformance?.track) {
      if (thisPerformance?.track.flags) {
        if (thisPerformance?.track.flags.includes("voc_avail")) {
          return <Tooltip title={TR.cm_vocal_version_available}><SvgIcon className="muvika-icon track-list-item-icon" component={VocIcon} /></Tooltip>;
        }
      }
    }
  };

  const primaryText = () => {
    return <span>{thisPerformance?.profile.name} - {thisPerformance?.track.title} {vocalImg()}</span>;
  };

  const secondaryText = thisPerformance?.track.artist;
  const pitch = thisPerformance?.pitch != 0 ? (thisPerformance?.pitch > 0 ? "+" : "") + thisPerformance?.pitch + " " : "";
  const pitchMinutes = pitch + " " + lengthToMinutes(thisPerformance?.track.length);

  const renderPlayed = () => {
    if (thisPerformance?.played) {
      let date = new Date(thisPerformance?.played);
      date.setMinutes(date.getMinutes() - timeDiff);
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
    }
  };

  const renderButton = () => {
    console.log("render again");
    if (thisPerformance) {
      return <ListItemButton sx={{
        lineHeight: 0.9,
        paddingLeft: "0.75rem !important",
        margin: 0,
        bgcolor: isMenuOpen ? 'rgba(255, 255, 255, 0.08)' : 'unset'
      }} onClick={() => {
        props.onAddPerformance(thisPerformance);
      }}>
        <ListItemText className="muvika-list-history-left" primary={renderPlayed()} />
        <ListItemText primary={primaryText()} secondary={secondaryText} />
        <ListItemText
          className="muvika-list-right-history"
          primary={pitchMinutes}
          secondary={thisPerformance?.track.kcode}
        />
        {renderFavoritesStar()}
        <IconButton
          id={"menu-button-" + thisPerformance?.track.track_id}
          color="white"
          component="label"
          size="large"
          aria-controls={isMenuOpen ? "menu-" + thisPerformance?.track.track_id : undefined}
          aria-haspopup="true"
          aria-expanded={isMenuOpen ? 'true' : undefined}
          onClick={(e) => {
            e.stopPropagation();
            openMenu(e);
          }} >
          <MenuIcon />
        </IconButton>
        <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus  
          id={"menu-" + thisPerformance?.track.track_id}
          open={isMenuOpen}
          anchorEl={anchorEl}
          onClose={(e) => {
            e.stopPropagation();
            handleMenuClose();
          }}
          MenuListProps={{
            'aria-labelledby': 'menu-button-' + thisPerformance?.track.track_id,
          }}
        >
          <MenuItem onClick={(e) => {
            e.stopPropagation();
            handleMenuClose();
            props.onAddPerformance(thisPerformance);
          }}>{TR.cm_add_to_playlist}</MenuItem>
          <MenuItem onClick={(e) => {
            e.stopPropagation();
            handleMenuClose();
            props.openDeleteDialog(thisPerformance);
          }}>{TR.cm_delete}</MenuItem>
        </Menu>
      </ListItemButton>;
    }
  };

  return (
    <div>
      {renderButton()}
    </div>
  );
}

export default HistoryListItem;